// Format currency
export const formatCurrency = (amount, currency = 'BHD') => {
  return `${parseFloat(amount).toFixed(3)} ${currency}`;
};

// Format date
export const formatDate = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};

// Format date time
export const formatDateTime = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Format phone number
export const formatPhone = (phone) => {
  if (!phone) return '';
  // Add Bahrain country code if not present
  if (!phone.startsWith('+973')) {
    return `+973 ${phone}`;
  }
  return phone;
};

// Calculate days remaining
export const calculateDaysRemaining = (expiryDate) => {
  if (!expiryDate) return null;
  const now = new Date();
  const expiry = new Date(expiryDate);
  const days = Math.ceil((expiry - now) / (1000 * 60 * 60 * 24));
  return days >= 0 ? days : 0;
};

// Validate email
export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Validate phone
export const isValidPhone = (phone) => {
  // Bahrain phone numbers
  const phoneRegex = /^(\+973)?[0-9]{8}$/;
  return phoneRegex.test(phone.replace(/\s/g, ''));
};

// Capitalize first letter
export const capitalize = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

// Get package display name
export const getPackageName = (packageType) => {
  switch (packageType) {
    case 'trial':
      return 'Free Trial';
    case 'base':
      return 'Base Package';
    case 'basic_plus':
      return 'Basic+ Package';
    default:
      return packageType;
  }
};

// Get status badge color
export const getStatusColor = (status) => {
  switch (status) {
    case 'active':
      return 'bg-green-100 text-green-800';
    case 'inactive':
      return 'bg-gray-100 text-gray-800';
    case 'expired':
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
